// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 199 ? "a1ffd009" : chunkId) + "." + {"167":"6d63413a41777684","199":"96a65479caab8075"}[chunkId] + ".js";
};